import { useEffect, useState } from 'react'

import RightPanelHeading from 'features/unifiedFlow/contentPage/components/layout/RightPanelHeading'
import { useVariantInsights } from 'features/unifiedFlow/contentPage/generate/context/VariantInsightsContext'

import SentimentAnalysisChart from './sentimentAnalysis/SentimentAnalysisChart'
import ExpandedIcons from './ExpandedIcons'
import InsightsCard from './InsightsCard'
import InsightsCategories from './InsightsCategories'
import PreviewLine from './PreviewLine'
import { ActivePanel, HandleActivePanelChange } from './RightSection'
import SentimentDescription from './SentimentDescription'

type Props = {
  activePanel: ActivePanel | undefined
  handleActivePanelChange: HandleActivePanelChange
}

const VariantInspector = ({ activePanel, handleActivePanelChange }: Props) => {
  const {
    state: { sentiments, defaultSentiment, category, variantId },
  } = useVariantInsights()

  const [selectedSentiment, setSelectedSentiment] = useState<
    string | undefined
  >(defaultSentiment?.name)

  useEffect(() => {
    setSelectedSentiment(defaultSentiment?.name)
  }, [defaultSentiment?.name])

  return (
    <div className="p-6 text-coolGray-800">
      <RightPanelHeading
        text="Variant inspector"
        className="mb-3"
        icons={
          <ExpandedIcons
            activePanel={activePanel}
            handleActivePanelChange={handleActivePanelChange}
          />
        }
      />
      <p className="text-xs font-normal mb-4 leading-5 text-base-700">
        Uncover key insights at a glance using Jacquard.
      </p>
      {category && <InsightsCategories category={category} />}
      {variantId && <PreviewLine variantId={variantId} />}
      <hr className="my-2 border-gold-400" />
      {sentiments && sentiments.length > 0 && (
        <InsightsCard
          title="Sentiment map"
          hasTitleIcons
          content={
            <SentimentAnalysisChart
              isLoading={false}
              selectedSentiment={selectedSentiment}
              series={sentiments}
              onClickSentiment={({ name }) => setSelectedSentiment(name)}
            />
          }
        />
      )}
      {selectedSentiment && (
        <SentimentDescription sentiment={selectedSentiment} />
      )}
    </div>
  )
}

export default VariantInspector
